
import {
  basic_navbar_new_style
} from '@/base/widgets_data_compatible';
export default {
  animateCombObj: {
    value: 0,
    animate: {
      _key: 'none'
    }
  },
  animateType: 'module_animation',
  pc_widgets_infor: {
    styleType: 'type_0',
    childStyleType:'type_0',
    navClick: 'true',
    navMarginright: 30,
    showLine: 'false',
    showLogo: 'false',
    showArrow: 'false',
    navTextAlign: 'center',
    navChildtextAlign: 'center',
    ...basic_navbar_new_style(),
    navheight: {
      radio_val: 'default',
      default: {
        height: 65,
        width: 80,
      },
      custom: {
        height: 65,
        width: 80,
      }
    },
    marginRight: {
      radio_val: 'default',
      default: {
        value: 0,
      },
      custom: {
        value: 0,
      }
    },
    navfont: {
      radio_val: 'default',
      default: {
        fontStyle: '',
        fsItalics: 'normal',
        fontUnderline: 'none',
        fontSize: 16,
        fontWidth: 'normal',
        fontColor: 'rgba(51,51,51,1)',
        fontSeColor: 'rgba(239,65,54,1)',
        fontFamily: 'Arial',
        pattern: 'pure_color',
        linear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
        sePattern: 'pure_color',
        seLinear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
      },
      custom: {
        fontStyle: '',
        fsItalics: 'normal',
        fontUnderline: 'none',
        fontSize: 16,
        fontWidth: 'normal',
        fontColor: 'rgba(51,51,51,1)',
        fontSeColor: 'rgba(153,153,153,1)',
        fontFamily: 'Arial',
        pattern: 'pure_color',
        linear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
        sePattern: 'pure_color',
        seLinear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
      }
    },
    borderRadius: {
      radio_val: 'default',
      default: {
        value: 0,
      },
      custom: {
        value: 0,
      }
    },
    border: {
      radio_val: 'default',
      default: {
        borderWidth: 0,
        borderLeftWidth: 0,
        borderRightWidth: 0,
        borderTopWidth: 0,
        borderBottomWidth: 0,
        borderStyle: 'solid',
        borderColor: "rgba(255, 255, 255,0)",
        borderSeColor: "rgba(0, 0, 0,0)",
        checkList: ['borderTopWidth', 'borderLeftWidth', 'borderRightWidth', 'borderBottomWidth'],
      },
      custom: {
        borderWidth: 0,
        borderLeftWidth: 0,
        borderRightWidth: 0,
        borderTopWidth: 0,
        borderBottomWidth: 0,
        borderStyle: 'solid',
        borderColor: "rgba(255, 255, 255,1)",
        borderSeColor: "rgba(0, 0, 0,0)",
        checkList: ['borderTopWidth', 'borderLeftWidth', 'borderRightWidth', 'borderBottomWidth'],
      }
    },
    splitLine: {
      radio_val: 'default',
      default: {
        rotate: 0,
        baseColor: 'rgba(255,255,255,0)',
        pattern: 'pure_color',
        linear_gradient: {
          start_color: "rgba(153,153,153,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
      },
      custom: {
        rotate: 0,
        baseColor: 'rgba(153,153,153,1)',
        pattern: 'pure_color',
        linear_gradient: {
          start_color: "rgba(153,153,153,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
      }
    },
    navBackground: {
      radio_val: 'default',
      default: {
        type: 'color', // 背景设置-类型
        img: '', // 背景设置-图片的URL
        color: 'rgba(255, 255, 255,0)', // 背景设置-颜色
        img_scale: 'scale_tiling', //图片缩放 填充、等比例、平铺、拉伸、原图
        tile_effect: 'img_default', //平铺效果 默认、缩放平铺、上、中-横向、下、中-纵向、左、右
        background_size: 'cover',
        background_repeat: 'no-repeat',
        background_position: 'center center' //图片位置
      },
      custom: {
        type: 'color', // 背景设置-类型
        img: '', // 背景设置-图片的URL
        color: 'rgba(255, 255, 255,1)', // 背景设置-颜色
        img_scale: 'scale_tiling', //图片缩放 填充、等比例、平铺、拉伸、原图
        tile_effect: 'img_default', //平铺效果 默认、缩放平铺、上、中-横向、下、中-纵向、左、右
        background_size: 'cover',
        background_repeat: 'no-repeat',
        background_position: 'center center' //图片位置
      }
    },
    navSeBackground: {
      radio_val: 'default',
      default: {
        type: 'color', // 背景设置-类型
        img: '', // 背景设置-图片的URL
        color: 'rgba(255, 255, 255,0)', // 背景设置-颜色
        img_scale: 'scale_tiling', //图片缩放 填充、等比例、平铺、拉伸、原图
        tile_effect: 'img_default', //平铺效果 默认、缩放平铺、上、中-横向、下、中-纵向、左、右
        background_size: 'cover',
        background_repeat: 'no-repeat',
        background_position: 'center center' //图片位置
      },
      custom: {
        type: 'color', // 背景设置-类型
        img: '', // 背景设置-图片的URL
        color: 'rgba(255, 255, 255,1)', // 背景设置-颜色
        img_scale: 'scale_tiling', //图片缩放 填充、等比例、平铺、拉伸、原图
        tile_effect: 'img_default', //平铺效果 默认、缩放平铺、上、中-横向、下、中-纵向、左、右
        background_size: 'cover',
        background_repeat: 'no-repeat',
        background_position: 'center center' //图片位置
      }
    },
    // navTextAlign: {
    //   radio_val: 'default', 
    //   default: {
    //     value: 'center'
    //   },
    //   custom: {
    //     value: 'center'
    //   },
    // },
    navChildfont: {
      radio_val: 'default',
      default: {
        fontStyle: '',
        fsItalics: 'normal',
        fontUnderline: 'none',
        fontSize: 16,
        fontWidth: 'normal',
        fontColor: 'rgba(51,51,51,1)',
        fontSeColor: 'rgba(153,153,153,1)',
        fontFamily: 'Arial',
        pattern: 'pure_color',
        linear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
        sePattern: 'pure_color',
        seLinear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
      },
      custom: {
        fontStyle: '',
        fsItalics: 'normal',
        fontUnderline: 'none',
        fontSize: 16,
        fontWidth: 'normal',
        fontColor: 'rgba(51,51,51,1)',
        fontSeColor: 'rgba(153,153,153,1)',
        fontFamily: 'Arial',
        pattern: 'pure_color',
        linear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
        sePattern: 'pure_color',
        seLinear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
      }
    },

    navChildBackground: {
      radio_val: 'default',
      default: {
        type: 'color', // 背景设置-类型
        img: '', // 背景设置-图片的URL
        color: 'rgba(255, 255, 255,1)', // 背景设置-颜色
        img_scale: 'scale_tiling', //图片缩放 填充、等比例、平铺、拉伸、原图
        tile_effect: 'img_default', //平铺效果 默认、缩放平铺、上、中-横向、下、中-纵向、左、右
        background_size: 'cover',
        background_repeat: 'no-repeat',
        background_position: 'center center' //图片位置
      },
      custom: {
        type: 'color', // 背景设置-类型
        img: '', // 背景设置-图片的URL
        color: 'rgba(255, 255, 255,1)', // 背景设置-颜色
        img_scale: 'scale_tiling', //图片缩放 填充、等比例、平铺、拉伸、原图
        tile_effect: 'img_default', //平铺效果 默认、缩放平铺、上、中-横向、下、中-纵向、左、右
        background_size: 'cover',
        background_repeat: 'no-repeat',
        background_position: 'center center' //图片位置
      }
    },
    navChildSeBackground: {
      radio_val: 'default',
      default: {
        type: 'color', // 背景设置-类型
        img: '', // 背景设置-图片的URL
        color: 'rgba(247, 247, 247, 1)', // 背景设置-颜色
        img_scale: 'scale_tiling', //图片缩放 填充、等比例、平铺、拉伸、原图
        tile_effect: 'img_default', //平铺效果 默认、缩放平铺、上、中-横向、下、中-纵向、左、右
        background_size: 'cover',
        background_repeat: 'no-repeat',
        background_position: 'center center' //图片位置
      },
      custom: {
        type: 'color', // 背景设置-类型
        img: '', // 背景设置-图片的URL
        color: 'rgba(255, 255, 255,1)', // 背景设置-颜色
        img_scale: 'scale_tiling', //图片缩放 填充、等比例、平铺、拉伸、原图
        tile_effect: 'img_default', //平铺效果 默认、缩放平铺、上、中-横向、下、中-纵向、左、右
        background_size: 'cover',
        background_repeat: 'no-repeat',
        background_position: 'center center' //图片位置
      }
    },
  },
  mb_widgets_infor: {},
  listArr: {
    url: '',
    link: '',
    logoUrl:''
  },

};



// WEBPACK FOOTER //
// ./src/widgets/basic_navbar/style.js